import { Button, VStack } from '@chakra-ui/react';
import { WIZARD_STEPS } from './stepMeta'

interface StepRailProps {
  current: number
  maxReached: number
  onJump: (index: number) => void
}

export function StepRail({ current, maxReached, onJump }: StepRailProps) {
  return (
    <VStack align="stretch" gap={1} minW="150px">
      {WIZARD_STEPS.map((s, i) => {
        // Every step up to and including the furthest reached is jump-back-able (<=, not <).
        const done = i <= maxReached
        const isCurrent = i === current
        return (
          <Button
            key={s.key}
            variant="ghost"
            size="sm"
            justifyContent="flex-start"
            fontWeight={isCurrent ? 'bold' : 'normal'}
            color={isCurrent ? 'accent' : done ? 'gray.800' : 'gray.400'}
            disabled={!done && !isCurrent}
            onClick={() => (done || isCurrent) && onJump(i)}
          >
            {isCurrent ? '● ' : done ? '✓ ' : '○ '}{s.label}
          </Button>
        );
      })}
    </VStack>
  );
}
